// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__qgSXo","topBottomGutter":"Layout_topBottomGutter__2KYLy"};